import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import services from './services.js';
//组件
import baseInfoForm from 'agent-base-info';
import contactForm from 'agent-contact';
import agentInfo from 'agent-info';
import operateAddressDialog from 'operateAddressDialog';
import selectStaffDialog from 'selectStaffDialog';
import agentMoney from 'components/agent-money/index.vue';

//import address from 'agent-address';
//import agentSignMaterielv from 'agent-sign-materiel';
export default {
    mixins: [services],
    components: {
        'base-info-form': baseInfoForm,
        'contact-form': contactForm,
        'agent-info': agentInfo,
        operateAddressDialog,
        selectStaffDialog,
        agentMoney
    },
    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data() {
        return {
            submiting: false,
            visiable: this.value,
            choiceAgentInfoIndex: '',
            agentDeliveryAddress: {},
            agentInfoNum: 1,
            agentList: [{}],
            baseInfo: null,
            contact: null,
            address: null,
            agentMoney: null,
            materiel: null,
            form:this.getSubmitFormData()
        };
    },
    computed: {
        sysSid: function() {
            return this.$store.state.sysSid;
        },
        sysSession: function() {
            return this.$store.state.sysSession;
        }
    },
    watch: {
        value: function(val) {
            this.visiable = this.value;
            if (val) {
                //this.getAgent();
            }
        },
        visiable: function(val) {
            this.$emit('input', val);
            if (!val) {
                this.$refs.baseInfo.resetFields();
                this.$refs.contact.resetFields();

                for (let i = 0; i < this.agentList.length; i++) {
                    this.$refs['agentInfo' + (i + 1)][0].resetFields();
                }

                this.agentList = [];
                this.agentInfoNum = 1;

                this.address = {
                    Consignee: null, //收货人
                    ConsigneeTel: null, //收货人电话
                    ConsigneeProvince: null, //省id
                    ConsigneeCity: null, //城市id
                    ConsigneeArea: null, //区\县id
                    ConsigneeAdress: null, //详细地址
                    Pay_Drawing: null //支付宝二维码;
                };
            }
        }
    },
    methods: {
        getSubmitFormData() {
            return cloneDeep({
            "ListAgentAreas": [],//代理区域列表
            "Customer": "",
            "Address": "",
            "Tel": "",
            "Intent_ProvId": 0,
            "Intent_CityId": 0,
            "Intent_AreaId": 0,
            "Intent_ProjectTypes": "",
            "ParentCustomerId": 0,
            "Provinces_Id": 0,
            "City_Id": 0,
            "Area_Id": 0,
            "CustomerLevel_Id": 0,
            "CustomerSource_Id": 0,
            "IsMajor": 0,
            "EmployeeNums": "",
            "RegisteredCapital": "",
            "Qualification": "",
            "C_Name": "",
            "C_Department": "",
            "C_Tel": "",
            "C_Email": "",
            "C_IDNumber": "",
            "C_IDNumber_Drawing": [],
            "C_QQ": "",
            "C_Weixin": "",
            "C_Remarks": "",
            "DataType": 0,
            "OpenClass": 0,
            "ProjectTypes": "",
            "BusEmployeeId": 0,
            "SocialCreditCode": "",
            "Corporation": "",
            "Corporation_IDNumber": "",
            "AuthDepositHolder": "",
            "TaxNumber": "",
            "Corporation_Drawing": [],
            "Company_Drawing": [],
            "AuthDepositHolder_Drawing": [],
            "AgentCode": "",
            "KingdeeAgentCode": ""
            });
        },
        showSelectStaffDialog() {
            this.$refs.refSelectStaffDialog.show();
        },
        //选择员工
        selectedStaff(item) {
            this.$refs.baseInfo.setStaffInfo(item);
        },
        //关闭弹窗
        close() {
            this.visiable = false;
        },
        //添加代理基本信息
        addAgentObj() {
            this.agentList.push({});
        },
        addAgent() {
            this.agentInfoNum += 1;
        },
        delAgentfn(item) {
            this.agentList.splice((item.index - 1), 1);
        },
        showChoicedAddressDiaolog(agentInfoIndex) {
            this.choiceAgentInfoIndex = agentInfoIndex;
            let selectedAgentInfo = this.$refs['agentInfo' + this.choiceAgentInfoIndex][0];
            let agentData = selectedAgentInfo.getAreaDetails();
            if ($.trim(agentData._provName).length == 0 || $.trim(agentData._cityName).length == 0) {
                return;
            }
            this.$nextTick(() => {
                this.$refs.refOperateAddressDialog.show({
                    CustomerId: this.id,
                    isLimitArea: true,
                    "ProvId": agentData.ProvId,
                    "CityId": agentData.CityId,
                    "AreaId": agentData.AreaId,
                    provName: agentData._provName,
                    cityName: agentData._cityName,
                    areaName: agentData._areaName
                });
            });
        },
        selectAddress(params) {
            this.$refs['agentInfo' + this.choiceAgentInfoIndex][0].refSetDeliveryAddress(params);
        },
        setEveryAgentInfoOfPolicy(item) {
            let PolicyType = 0,
                ProjectType = [];
            for (let i = 0; i < this.agentList.length; i++) {
                let agentInfoCell = this.$refs['agentInfo' + (i + 1)][0],
                    policyResult = agentInfoCell.getPolicyValue();
                ProjectType.push(agentInfoCell.getProjectType());
                if ($.trim(policyResult.policyName).length > 0) {
                    PolicyType = policyResult.PolicyType;
                }
            }

            this.$refs.refAgentMoney.changeHiPrePayMoneyLabel({
                ProjectType: ProjectType.join(","),
                PolicyType: PolicyType
            });
        },
        submit() {
            this.$nextTick(() => {
                let baseInfo = this.$refs.baseInfo.validate();
                let contact = this.$refs.contact.validate();
                let materiel = {};
                let agentAddress = {};
                let ListAgentAreas = [];
                for (let i = 0; i < this.agentList.length; i++) {
                    let data = this.$refs['agentInfo' + (i + 1)][0].validate();
                    ListAgentAreas.push(data);
                }

                let agentInfoResult = ListAgentAreas.every(function(result) {
                    return result;
                });
                let agentMoney = this.$refs.refAgentMoney.validate();
                if (!!baseInfo && !!contact && agentInfoResult && agentMoney) {
                    let data = Object.assign({}, baseInfo, contact, agentAddress, materiel, { 'ListAgentAreas': ListAgentAreas }, agentMoney);
                    data.Id = this.id;
                    //console.log(data)
                    this.AddMeetAgent(data);
                }
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/common/components/agent-add/vm.js